/* eslint-disable no-fallthrough, import/no-default-export,jsx-a11y/iframe-has-title */
import React from 'react';
import styles from './help.less';

interface HelpProps {
  onIFrameLoaded: () => void;
}

class Help extends React.Component<HelpProps> {
  iFrame: HTMLIFrameElement | null;

  componentDidMount() {
    window.addEventListener('message', this.receiveMessage.bind(this));
  }

  coompnentWillUnmount() {
    window.removeEventListener('message', this.receiveMessage.bind(this));
  }

  shouldComponentUpdate() {
    return false;
  }

  receiveMessage = (e: MessageEvent) => {
    if (this.iFrame) {
      if (e.source === this.iFrame.contentWindow) {
        const { type, value } = e.data;
        switch (type) {
          case 'resize': {
            this.props.onIFrameLoaded();
            const currentHeight = parseFloat(this.iFrame.style.height || '');
            if (
              !currentHeight ||
              (currentHeight < value && currentHeight - value < 50)
            ) {
              this.iFrame.style.height = `${value}px`;
            }
          }
          default:
            return;
        }
      }
    }
  };

  render() {
    return (
      <iframe
        className={styles.helpIFrame}
        sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
        ref={(ref) => (this.iFrame = ref)}
        src={`/contact?compact=1&trello=1&url=${encodeURIComponent(
          location.href,
        )}&source=from%20in%20app`}
      />
    );
  }
}

export default Help;
